import { Component, Input, OnInit } from "@angular/core";
import * as Chart from "chart.js";
import { AuthService } from "../../services/auth-service/auth.service";
import { DashboardService } from "../../services/dashboard/dashboard.service";

@Component({
  selector: "app-polar-area-chart",
  templateUrl: "./polar-area-chart.component.html",
  styleUrls: ["./polar-area-chart.component.scss"],
})
export class PolarAreaChartComponent implements OnInit {
  @Input() backgroundColorip: any;
  @Input() datasetip: any;
  @Input() labelsip: any;
  @Input() polarTitle: any;
  public chart: any = null;
  data: any;
  role: any;
  constructor(
    private dashboardService: DashboardService,
    private authService: AuthService
  ) {
    this.role = this.authService.getPersonId();
    if (this.role == "2") {
      this.dashboardService._getSPAPolarChartObserver.subscribe((res) => {
        this.datasetip = res;

        this.renderChart();
      });

      this.dashboardService._getSPAPolarChartLabelObserver.subscribe((res) => {
        this.labelsip = res;
        this.renderChart();
      });
    }

    if (this.role == "3") {
      this.dashboardService._getAdvertisersPolarGraphObserver.subscribe(
        (res: any) => {
          this.datasetip = res?.data;
          this.labelsip = res?.label;
          this.backgroundColorip = res?.color;
          this.renderChart();
        }
      );
    }
  }
  ngOnInit() {
    this.renderChart();
  }
  renderChart() {
    this.data = {
      labels: this.labelsip,
      datasets: [
        {
          label: "Dataset 1",
          data: this.datasetip,
          backgroundColor: this.backgroundColorip,
        },
      ],
    };
    this.chart ? this.chart.destroy() : "";
    Chart.defaults.global.animation.duration = 2000;
    this.chart = new Chart("polarArea", {
      type: "polarArea",
      data: this.data,
      options: {
        responsive: true,
        legend: {
          position: "right",
          labels: {
            usePointStyle: true,
          },
        },
        scale: {
          display: false,
          ticks: {
            display: false,
            maxTicksLimit: 1,
          },
        },
      },
    });
  }
}
